import React from 'react';
import { Box, Typography, Paper, Chip, Button, Divider } from '@mui/material';
import Header from '../widgets/Header';
import { useTranslation } from 'react-i18next';

function MySubscription({ user }) {

    const { t } = useTranslation();

    function formatPrice(amount, currency, divisor = 1) {
        return amount
            ? (amount / 100 / divisor).toLocaleString('pt-PT', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }) + " " + currency
            : "N/A";
    }

    const monthlyPrice = user.plan?.charge_amount 
    ? formatPrice(
        user.plan?.charge_amount,
        user.plan?.charge_currency,
        12
    )
    : null;

    function planName() {
      return user.plan?.plan_name || user.plan?.offer_name || t('my_subscription.no_plan');
    }
    
    function planPrice() {
      if (!user.plan?.charge_amount) return "N/A";

      return formatPrice(
        user.plan?.charge_amount,
        user.plan?.charge_currency
      );
    }

    function renewalDate() {
      if (!user.plan?.created_at) return "N/A";

      const createdAt = new Date(user.plan?.created_at);
      createdAt.setFullYear(createdAt.getFullYear() + 1);

      const renewalDate = createdAt?.toLocaleDateString('pt-PT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });

      return renewalDate
    }

    return (
            <Box>
              <Header text={t('my_subscription.title')} />
              <Box sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
                <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 1 }} elevation={1}>
        
                  {/* Top Row */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      alignItems: { xs: 'flex-start', sm: 'center' },
                      justifyContent: 'space-between',
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <Typography variant="h6">
                      {planName()}
                    </Typography>
        
                    {monthlyPrice && (
                      <Typography variant="body2" sx={{ color: '#A9A9A9' }}>
                        {t('my_subscription.monthly_rate', { monthlyPrice })}
                      </Typography>
                    )}
                  </Box>
        
                  <Divider sx={{ my: 3 }} />
        
                  {/* Info Grid */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      gap: 3,
                      alignItems: { xs: 'flex-start', md: 'center' },
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {t('my_subscription.plan_price')}
                      </Typography>
                      <Typography variant="body1">{planPrice()}</Typography>
                    </Box>
        
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0 }}>
                        {t('my_subscription.status')}
                      </Typography>
                      {user.plan ? (
                        <Chip label={t('my_subscription.active')} color="success" />
                      ) : (
                        <Chip label={t('my_subscription.inactive')} />
                      )}
                    </Box>
        
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {t('my_subscription.renewal_date')}
                      </Typography>
                      <Typography variant="body1">
                        {renewalDate()}
                      </Typography>
                    </Box>
        
                    <Button
                      variant="outlined"
                      color="primary"
                      sx={{ alignSelf: { xs: 'stretch', md: 'center' }, mt: { xs: 2, md: 0 } }}
                      onClick={() => alert('🚧 Soon!')}
                    >
                      {t('my_subscription.change_plan')}
                    </Button>
                  </Box>
                </Paper>
              </Box>
            </Box>
    );
}

export default MySubscription;